import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { addToast, clearToasts, removeToast, resetToasts } from './store/actions.js';
import toastsReducer from './store/reducer.js';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);

var ToastsContext = function ToastsContext(props) {
  var initialState = {
    toasts: []
  };

  var _React$useReducer = React.useReducer(toastsReducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return /*#__PURE__*/jsx(Context.Provider, {
    value: {
      addToast: addToast,
      clearToasts: clearToasts,
      dispatch: dispatch,
      removeToast: removeToast,
      resetToasts: resetToasts,
      toasts: state.toasts
    },
    children: props.children
  });
};

ToastsContext.propTypes = {
  "children": _PropTypes.node
};
ToastsContext.displayName = "ToastsContext";
function useToastsContext() {
  var toastsContext = React.useContext(Context);

  if (!toastsContext) {
    throw new TypeError("No ToastsContext provided");
  }

  return toastsContext;
}
var useToasts = function useToasts() {
  var toastsContext = useToastsContext();
  var dispatch = toastsContext.dispatch;
  return {
    addToast: function addToast(payload) {
      return dispatch(toastsContext.addToast(payload));
    },
    clearToasts: function clearToasts() {
      return dispatch(toastsContext.clearToasts());
    },
    removeToast: function removeToast(id) {
      return dispatch(toastsContext.removeToast(id));
    },
    resetToasts: function resetToasts() {
      return dispatch(toastsContext.resetToasts());
    }
  };
};

export { Context, ToastsContext, useToasts, useToastsContext };
